// Bulk task actions run the existing per-task operations (there is no atomic batch endpoint), so
// some can succeed while others fail. The result says which, so the UI can report it honestly.
import type { EnqueueResult } from "./outbox";

export interface BulkResult<T> {
  ok: T[];
  failed: T[];
}

/** Run `op` for every item concurrently. "Queued" (offline) counts as done: the outbox will send it. */
export async function runBulk<T>(items: T[], op: (item: T) => Promise<EnqueueResult | void | undefined>): Promise<BulkResult<T>> {
  const results = await Promise.all(
    items.map(async (item) => {
      try {
        const r = await op(item);
        return !r || r.status !== "failed";
      } catch {
        return false;
      }
    }),
  );
  return { ok: items.filter((_, i) => results[i]), failed: items.filter((_, i) => !results[i]) };
}
